module.exports = __webpack_public_path__ + "front/img/20220803001_video.cd6a6a5e.jpg";